
import { defineComponent } from 'vue';
import { IOrder } from '@/types/models';
import { IElForm, IElTable } from '@/types/element';
import utils from '@/utils';
import api from '@/api/my/invoices';

interface IForm {
  type: string;
  taxTitle: string;
  taxNo: string;
  taxAddress: string;
  taxTel: string;
  taxBankName: string;
  taxBankNo: string;
  deliveryName: string;
  deliveryTel: string;
  deliveryAddress: string;
  email: string;
}

interface IState {
  orders: IOrder[];
  multipleSelection: IOrder[];
  form: IForm;
  isSubmitting: boolean;
}

export default defineComponent({
  name: 'ApplyInvoice',
  data() {
    return {
      orders: [],
      multipleSelection: [],
      form: {
        type: 'false-false',
        taxTitle: '',
        taxNo: '',
        taxAddress: '',
        taxTel: '',
        taxBankName: '',
        taxBankNo: '',
        deliveryName: '',
        deliveryTel: '',
        deliveryAddress: '',
        email: '',
      },
      isSubmitting: false,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          isApply: true,
        },
        (res) => {
          if (!res) return;

          this.orders = res.orders;
          if (res.lastInvoice) {
            this.form.type = `${res.lastInvoice.isVatSpecial}-${res.lastInvoice.isElectronic}`;
            // if (this.form.type !== 'false-false' && this.form.type !== 'true-false' && this.form.type !== 'true-false') {
            //   this.form.type = 'false-false';
            // }
            this.form.taxTitle = res.lastInvoice.taxTitle;
            this.form.taxNo = res.lastInvoice.taxNo;
            this.form.taxAddress = res.lastInvoice.taxAddress;
            this.form.taxTel = res.lastInvoice.taxTel;
            this.form.taxBankName = res.lastInvoice.taxBankName;
            this.form.taxBankNo = res.lastInvoice.taxBankNo;
            this.form.deliveryName = res.lastInvoice.deliveryName;
            this.form.deliveryTel = res.lastInvoice.deliveryTel;
            this.form.deliveryAddress = res.lastInvoice.deliveryAddress;
            this.form.email = res.lastInvoice.email;
          }
        },
      );
    },

    isVatSpecial() {
      if (this.form.type && this.form.type.indexOf('-') !== -1) {
        return this.form.type.split('-')[0] === 'true';
      }
      return false;
    },

    isElectronic() {
      if (this.form.type && this.form.type.indexOf('-') !== -1) {
        return this.form.type.split('-')[1] === 'true';
      }
      return false;
    },

    getResourceType(item: IOrder) {
      return utils.getResourceType(item.resourceType);
    },

    getChannel(item: IOrder) {
      return utils.getPayChannel(item.channel);
    },

    getUrl(item: IOrder) {
      if (item.resourceType === 'Theme') {
        return `/templates/template.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Extension') {
        return `/plugins/plugin.html?resourceId=${item.resourceId}`;
      }
      if (item.resourceType === 'Service') {
        return '/vip/#pricing';
      }
      return '#';
    },

    handleSelectionChange(val: IOrder[]) {
      this.multipleSelection = val;
    },

    toggleSelection(row: IOrder) {
      (this.$refs.multipleTable as IElTable).toggleRowSelection(row);
    },

    tableRowClassName(scope: { row: IOrder }) {
      if (this.multipleSelection.indexOf(scope.row) !== -1) {
        return 'current-row';
      }
      return '';
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.isSubmitting = true;
          api.submit(
            {
              ...this.form,
              isVatSpecial: this.isVatSpecial(),
              isElectronic: this.isElectronic(),
              orderNos: this.orderNos,
              amount: this.amount,
            },
            (res) => {
              if (!res.value) return;
              utils.success('发票申请成功！');
              this.apiGet();
              this.isSubmitting = false;
            },
            () => {
              this.isSubmitting = false;
            },
          );
        }
      });
    },
  },
  computed: {
    isChecked(): boolean {
      return this.multipleSelection.length > 0;
    },

    orderNos(): string[] {
      const retVal = [];
      for (let i = 0; i < this.multipleSelection.length; i += 1) {
        const item = this.multipleSelection[i];
        retVal.push(item.orderNo);
      }
      return retVal;
    },

    amount(): number {
      let retVal = 0;
      for (let i = 0; i < this.multipleSelection.length; i += 1) {
        const item = this.multipleSelection[i];
        retVal += item.amount;
      }
      return retVal;
    },
  },
  mounted() {
    this.apiGet();
  },
});
